import { render, staticRenderFns } from "./TheoryPracticeWorkshopsPaymentSuccess.vue?vue&type=template&id=5b9ccd06&scoped=true&"
import script from "./TheoryPracticeWorkshopsPaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./TheoryPracticeWorkshopsPaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TheoryPracticeWorkshopsPaymentSuccess.vue?vue&type=style&index=0&id=5b9ccd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ccd06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
